import { Reveal } from "@/components/Reveal";
import { BookButton } from "@/components/Navbar";
import { imgSrc } from "@/lib/api";

function RoomCard({ room, large }) {
  return (
    <article className={`card-hover group relative flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-charcoal-800 ${large ? "md:col-span-8" : "md:col-span-4"}`} data-testid={`room-card-${room.id}`}>
      <div className="relative overflow-hidden">
        <img src={imgSrc(room.image)} alt={room.name} loading="lazy"
          className={`w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105 ${large ? "aspect-[16/8]" : "aspect-[16/10]"}`} />
        {room.primary && (
          <span className="absolute left-4 top-4 rounded-full bg-copper px-4 py-1.5 text-[10px] font-mono uppercase tracking-[0.2em] text-charcoal">
            {room.tagline || "Primary unit"}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-6 lg:p-8">
        <h3 className={`font-serif text-cream ${large ? "text-2xl lg:text-3xl" : "text-xl"}`}>{room.name}</h3>
        <p className="mt-3 flex-1 text-sm font-light leading-relaxed text-cream-muted">{room.description}</p>
        {room.specs?.length > 0 && (
          <ul className="mt-5 flex flex-wrap gap-2">
            {room.specs.filter((s) => s.value).map((s, i) => (
              <li key={i} className="rounded-full border border-copper/25 px-3 py-1 text-[11px] text-cream-muted">
                <span className="text-copper-300">{s.label}:</span> {s.value}
              </li>
            ))}
          </ul>
        )}
        {room.price_note && <p className="mt-4 text-xs italic text-cream-dim">{room.price_note}</p>}
        <div className="mt-6">
          <BookButton testid={`room-book-btn-${room.id}`}>{large ? "Book the Entire Villa" : "Check Availability"}</BookButton>
        </div>
      </div>
    </article>
  );
}

export default function Rooms({ rooms }) {
  if (!rooms?.length) return null;
  return (
    <section id="rooms" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-20 sm:px-8 lg:px-16 lg:py-32" data-testid="rooms-section">
      <Reveal>
        <p className="eyebrow mb-4">Stay</p>
        <h2 className="max-w-3xl font-serif text-2xl leading-snug tracking-tight text-cream sm:text-3xl lg:text-4xl">
          One villa. <span className="italic text-copper-gradient">Entirely yours.</span>
        </h2>
        <p className="mt-4 max-w-xl text-base font-light text-cream-muted">Book the whole 4 BHK villa for your people — four bedrooms, lounge, dining and a full kitchen.</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
        {rooms.map((room, i) => (
          <Reveal key={room.id || i} className={room.primary ? "md:col-span-8" : "md:col-span-4"} delay={0.08 * i}>
            <RoomCard room={room} large={!!room.primary} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
